// src/components/Card.jsx
import React from "react";
import { useTheme } from "../context/ThemeContext";

const Card = ({ children, type, padding, maxWidth, minWidth, className }) => {
    const { themeStyles } = useTheme();

    return (
        <div
            className={`rounded-lg shadow-md border ${className}`}
            style={{
                display: "flex",
                flexDirection: type,
                background: themeStyles.cardBackground,
                padding: padding ?? "20px",
                borderRadius: "10px",
                marginBottom: "20px",
                maxWidth: maxWidth ? 700 : 'auto',
                minWidth: minWidth ? 700 : 'auto'
            }}
        >
            {children}
        </div>
    );
};

export default Card;
